module.exports = __webpack_public_path__ + "img/Slice2-min.698c090f.png";